import { html } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './input-group.lit.scss';

/**
 * @component {kat-input-group} KatalInputgroup Input groups combine multiple input types, such as text inputs, static text, icons, and dropdowns, into one compound input.
 * @status Development
 * @guideline Do Use kat-input, kat-icon, and other elements inside the input group to build a control with currency, symbols, and a space for the user to type.
 * @guideline Do Be sure to set placeholder and type attributes on your kat-input providing hints for users and giving context for assistive devices.
 * @slot default Can accept a span, div, kat-input, kat-icon, kat-predictive-input, and kat-dropdown.
 * @example Currency {"content": "<kat-icon name=\"euro_symbol\"><\/kat-icon>\r\n<kat-input placeholder=\"123.45\" type=\"number\"><\/kat-input>"}
 * @example PhoneNumber {"content": "<span id=\"inputGroupFlagSpan\"><kat-flag country=\"us\"><\/kat-flag><\/span>\r\n<span id=\"inputGroupCountryCodeSpan\">+1<\/span>\r\n<kat-input id=\"inputGroupTelephoneInput\" placeholder=\"2223334444\" type=\"tel\"><\/kat-input>\r\n<kat-icon id=\"inputGroupPhoneIcon\" name=\"phone\"><\/kat-icon>"}
 * @example Dropdown {"content": "<kat-input placeholder=\"thing\"></kat-input><kat-dropdown options=\"[{ &quot;name&quot;: &quot;car&quot;,&quot;value&quot;: &quot;carValue&quot;},{&quot;name&quot;: &quot;truck&quot;,&quot;value&quot;: &quot;truckValue&quot;},{&quot;name&quot;: &quot;house&quot;,&quot;value&quot;: &quot;houseValue&quot;}]\"></kat-dropdown>"}
 * @example Email {"content": "<kat-icon class=\"text-storm\" name=\"mail\"><\/kat-icon>\r\n<kat-input placeholder=\"username\" type=\"email\"><\/kat-input>\r\n<span>@amazon.com<\/span>"}
 * @example Password {"content": "<kat-icon name=\"lock\"><\/kat-icon>\r\n<kat-input type=\"password\"><\/kat-input>"}
 */
@register('kat-input-group')
export class KatInputGroup extends KatLitElement {
  static get styles() {
    return [baseStyles, styles];
  }

  render() {
    return html`<div class="inner"><slot></slot></div>`;
  }
}
